import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Build from "../views/Build.vue";
import Layout from '../components/layout/layout.vue'

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {path: '/', redirect: '/app/home'},
 
  {
    path: '/app',
    name: 'Layout',
    component: Layout,
    children:[
  
      {
        path: "home",
        name: "Build",
        component: Build,
      },
    ]
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router;
